import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { v4 as uuidv4 } from 'uuid';

import { DEFAULT_CURRENCY } from '@/locale';
import { TransactionFetchData } from '@/api/payments/fetchTransaction';

export type ProviderName =
  'STRIPE'
  | 'BRAINTREE'
  | 'PAYPAL'
  | 'BRAINTREE_GOOGLEPAY'
  | 'BRAINTREE_APPLEPAY'
  | 'GOCARDLESS';

export interface PaymentSelectState {
  provider?: ProviderName,
  orderReference: string,
  giftaid: boolean,
  amount: number,
  currentMoneybuyPosition: number | null,
  currency: string,
  fixedTransactionId?: string,
}

const initialState: Readonly<PaymentSelectState> = {
  orderReference: '',
  giftaid: false,
  amount: 5,
  currentMoneybuyPosition: null,
  currency: DEFAULT_CURRENCY,
};

export const paymentSelectSlice = createSlice({
  name: 'paymentSelect',
  initialState,
  reducers: {
    initOrderReference(state: PaymentSelectState) {
      return {
        ...state,
        orderReference: uuidv4(),
      };
    },
    setProvider(state: PaymentSelectState, action: PayloadAction<ProviderName>) {
      return {
        ...state,
        provider: action.payload,
      };
    },
    updatePaymentSelectFields(state: PaymentSelectState, action: PayloadAction<Partial<PaymentSelectState>>) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setPaymentSelectFromTransaction(state: PaymentSelectState, action: PayloadAction<TransactionFetchData>) {
      return {
        ...state,
        giftaid: false,
        amount: action.payload.amount,
        currency: action.payload.currency,
      };
    },
    setFixedTransactionId(state: PaymentSelectState, action: PayloadAction<string>) {
      return {
        ...state,
        fixedTransactionId: action.payload,
      };
    },
  },
});

export const {
  initOrderReference,
  setProvider,
  updatePaymentSelectFields,
  setPaymentSelectFromTransaction,
  setFixedTransactionId,
} = paymentSelectSlice.actions;
